import React, { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { Controller } from 'react-hook-form';
import { valueByName } from './form_utils';

const PREFIX = 'ECSwitchField';

const classes = {
  switch__track: `${PREFIX}-switch__track`,
  switch__thumb: `${PREFIX}-switch__thumb`,
  switch: `${PREFIX}-switch`,
  switch__label_check: `${PREFIX}-switch__label_check`,
};

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  [`& .${classes.switch__track}`]: {
    backgroundColor: '#213955 !important',
    opacity: 0.5,
  },

  [`& .${classes.switch__thumb}`]: {
    background: '#213955',
  },

  [`& .${classes.switch}`]: {
    fontFamily: 'Roboto, sans-serif',
    color: '#90A4AE',
    fontSize: 14,
  },

  [`& .${classes.switch__label_check}`]: {
    color: '#3F51B5',
  },
}));

export const ECSwitchField = props => {
  const { name, label, form, defaultValue, initial, ...rest } = props;

  const dv = valueByName(initial, name) || defaultValue || false;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => form.setValue(name, dv), []);

  return (
    <FormControlLabel
      control={
        <Controller
          control={form.control}
          name={name}
          defaultValue={dv}
          render={({ field }) => (
            <Switch
              {...field}
              checked={field.value || false}
              inputProps={{
                'aria-label': 'primary switch',
              }}
              classes={{
                track: classes.switch__track,
                thumb: classes.switch__thumb,
              }}
              {...rest}
            />
          )}
        />
      }
      label={label}
      style={{ marginRight: 0 }}
    />
  );
};

ECSwitchField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  form: PropTypes.object,
  defaultValue: PropTypes.any,
  initial: PropTypes.object,
};
